const promobarDesktopCopyButton = document.querySelector('.topbar-desktop.topbar__announcement a');
const promobarMobileCopyButton = document.querySelector('.topbar-mobile.topbar__announcement a');

if (promobarDesktopCopyButton && promobarMobileCopyButton) {
  const promobarLinkDataLayer = {
    event: 'navigation_interaction',
    section: 'promo_top_bar',
    element: 'link_button',
    element_value: promobarDesktopCopyButton.innerText,
    interaction_type: 'click',
  };

  promobarDesktopCopyButton.addEventListener('click', async (event) => {
    event.preventDefault();
    await dataLayerPromise(promobarLinkDataLayer);
    continueLinkClickEvent(event, promobarDesktopCopyButton.href);
  });
  promobarMobileCopyButton.addEventListener('click', async (event) => {
    event.preventDefault();
    await dataLayerPromise(promobarLinkDataLayer);
    continueLinkClickEvent(event, promobarMobileCopyButton.href);
  });
}

const topbarDesktopLinks = document.querySelectorAll('.topbar__links a');

topbarDesktopLinks.forEach((button) => {
  button.addEventListener('click', async (event) => {
    event.preventDefault();
    const buttonLink = button.getAttribute('data-link');
    const buttonCopy = button.getAttribute('data-copy');

    await dataLayerPromise({
      event: 'navigation_interaction',
      section: 'promo_top_bar',
      element: 'text_button',
      element_value: buttonCopy.replace(/\s/g, '_'),
      interaction_type: 'click',
    });
    continueLinkClickEvent(event, buttonLink);
  });
});

const input = document.querySelector('.search__input');
let isFirstLetterTyped = false;
input.addEventListener('input', (e) => {
  if (!isFirstLetterTyped && e.target.value.length > 0) {
    Shopify.analytics.publish('search_start');
    dataLayer.push({
      event: 'search_start',
    });
    isFirstLetterTyped = true;
  }
});

const accountIcon = document.querySelector('.right-menu-icons.account-icon');

accountIcon.addEventListener('click', async (event) => {
  event.preventDefault();

  await dataLayerPromise({
    event: 'navigation_interaction',
    section: 'top_bar',
    element: 'icon_button',
    element_value: 'your_account',
    interaction_type: 'click',
  });
  continueLinkClickEvent(event, '/account');
});

const cartIcon = document.querySelector('.right-menu-icons.cart-icon');
cartIcon.addEventListener('click', () => {
  dataLayerPromise({
    event: 'navigation_interaction',
    section: 'top_bar',
    element: 'icon_button',
    element_value: 'shopping_basket',
    interaction_type: 'click',
  });
});
